import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}
/** @jsx jsx */


import { useState } from 'react';
import { jsx } from 'theme-ui';
import { useConfig } from 'docz';
import Iframe from 'react-frame-component';
import ReactResizeDetector from 'react-resize-detector';
import * as styles from './styles';
import { jsx as ___EmotionJSX } from "@emotion/core";
var CLEAR_PADDING = "<style> body { padding: 0; margin: 0; }  </style>";
var INITIAL_IFRAME_CONTENT = "<!DOCTYPE html><html><head> " + CLEAR_PADDING + " </head><body><div></div></body></html>";

var IframeWrapper = function IframeWrapper(_ref) {
  var children = _ref.children,
      style = _ref.style;

  var _useState = useState(),
      containerHeight = _useState[0],
      setHeight = _useState[1];

  return jsx(Iframe, {
    initialContent: INITIAL_IFRAME_CONTENT,
    sx: _objectSpread(_objectSpread({}, styles.wrapper()), {}, {
      style: style,
      height: containerHeight
    })
  }, children, jsx(ReactResizeDetector, {
    handleHeight: true,
    onResize: function onResize(_ref2) {
      var height = _ref2.height;
      setHeight(height);
    }
  }));
};

var NormalWrapper = function NormalWrapper(_ref3) {
  var children = _ref3.children,
      style = _ref3.style;
  return jsx("div", {
    sx: _objectSpread(_objectSpread({}, styles.wrapper()), style)
  }, children);
};

export var Wrapper = function Wrapper(_ref4) {
  var children = _ref4.children,
      content = _ref4.content,
      useScoping = _ref4.useScoping,
      showingCode = _ref4.showingCode;

  var _useConfig = useConfig(),
      useScopingInPlayground = _useConfig.themeConfig.useScopingInPlayground;

  var Element = useScoping || useScopingInPlayground ? IframeWrapper : NormalWrapper;
  return jsx(Element, {
    style: styles.wrapperBorder(content, showingCode)
  }, children);
};

if (typeof Wrapper !== 'undefined' && Wrapper && Wrapper === Object(Wrapper) && Object.isExtensible(Wrapper) && !Wrapper.hasOwnProperty('__filemeta')) {
  Object.defineProperty(Wrapper, '__filemeta', {
    configurable: true,
    value: {
      name: "Wrapper",
      filename: "node_modules/gatsby-theme-docz/src/components/Playground/Wrapper.js"
    }
  });
}